import { SYSTEM_HEADERS, SYSTEM_MESSAGES } from "@/helpers/constants";
import dayjs from "dayjs";

export default {
  /**
   * System messages
   * @param state
   * @param getters
   * @param rootState
   * @return {Object}
   */
  systemMessages: (state, getters, rootState) => {
    return Object.assign(SYSTEM_MESSAGES, rootState.event.config.defaultSystemMessages || {});
  },

  /**
   * System headers for announcement banner
   * @param state
   * @param getters
   * @param rootState
   * @return {Object}
   */
  systemHeaders: (state, getters, rootState) => {
    return Object.assign(SYSTEM_HEADERS, rootState.event.config.defaultSystemHeaders || {});
  },

  isEventStarted(state) {
    return state.millisecondsToEvent <= 0;
  },
  eventStartDate(state, getters, rootState) {
    // We need to make context datetime to look like it's in event timezone
    // because admin logic converts any datetimepicker value as it is in event timezone
    const fixedTimezoneString = dayjs(rootState.event.context.TIME_EVENT_START)
      .tz(getters.globalEventTimezone)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    return dayjs.tz(fixedTimezoneString, getters.eventTimezone);
  },
  globalEventTimezone(state, getters, rootState) {
    return rootState.event.context.EVENT_GLOBALS.TIMEZONE;
  },
  eventTimezone(state, getters, rootState) {
    return JSON.parse(rootState.event.context.TIME_ZONE).timezone;
  },
  canJoinEventByTime(state, getters, rootState) {
    if (!rootState.event.context.RESTRICT_ACCESS_FOR_ATTENDEES) return true;
    if (getters.isEventStarted) {
      return getters.eventStartDate.add(rootState.event.context.TIME_AFTER_OPENING, "hour").isAfter(dayjs());
    }
    return true;
  },
  canEnterEvent(state, getters, rootState) {
    if (!rootState.event.context.RESTRICT_ACCESS_FOR_ATTENDEES) return true;
    if (getters.isEventStarted) {
      return getters.eventStartDate.add(rootState.event.context.TIME_AFTER_OPENING, "hour").isAfter(dayjs());
    }
    return getters.eventStartDate.subtract(rootState.event.context.TIME_BEFORE_OPENING, "hour").isBefore(dayjs());
  }
};
